import ScheduleSection from "@/components/feature/schedule/ScheduleSection";

// 메인 홈 «클럽 일정» 섹션 — /calendar 페이지와 같은 ScheduleSection 을 재사용한다.
export default function ScheduleHomeSection() {
  return (
    <section className="w-full bg-background-50 px-4 py-14 md:px-6 md:py-16">
      <div className="mx-auto max-w-6xl">
        <div className="mb-6">
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            클럽 일정
          </h2>
          <p className="mt-2 text-foreground-600">
            정기모임 · 봉사일정 · 회원 생일을 한눈에
          </p>
        </div>
        <ScheduleSection />
      </div>
    </section>
  );
}